export default __webpack_public_path__ + "static/media/iconUserCircle.055b731c.svg";